var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGgTitlebarArrowDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-right-chevron-8563331",
    transform: "translate(-56.3 -35.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5898",
    "data-name": "\\uD328\\uC2A4 5898",
    d: "M60.007,35.5H56.3l5.678,5.431a.088.088,0,0,1,0,.136L56.3,46.5h3.707L65.758,41Z",
    transform: "translate(0 0)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5899",
    "data-name": "\\uD328\\uC2A4 5899",
    d: "M220.712,35.5H217l5.678,5.431a.088.088,0,0,1,0,.136L217,46.5h3.712l5.747-5.5Z",
    transform: "translate(-154.163 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgTitlebarArrowDefault);
export default __webpack_public_path__ + "static/media/gg_titlebar_arrow_default.8320fbb9b28ab2291a30571e0c513a3b.svg";
export { ForwardRef as ReactComponent };